<template>
    <div class="leaveMessage">
        <div class="lmMain">
          <div class="lmMainTitle">
            <div class="lmtTitle">请您留言</div>
            <div class="lmtImg" @click="close()"><img :src="lmtImg" alt=""></div>
          </div>
          <div class="lmMainContent">
              <select v-model="type">
                  <option value="1">配驾包车</option>
                  <option value="2">自驾租车</option>
              </select>
            <input type="text" placeholder="您的姓名" v-model="name">
            <input type="text" placeholder="手机号码（必填）" maxlength="11" v-model="phone">
            <textarea name="" id="" cols="30" rows="10" placeholder="请输入您的用车需求，我们马上联系您" v-model="remark"></textarea>
          </div>
          <div class="lmMainSubmit"><button @click="submit">提交</button></div>
        </div>
    </div>
</template>

<script>
    import {Toast} from 'vant';
    export default {
        name: '',
        props:['publicData'],
        data () {
            return {
              lmtImg:require("../../assets/icon_close.png"),
              lmMask:false,
                name:'',
                phone:'',
                remark:'',
                type:1,
            }
        },
        methods:{
          close:function(){
            let fakt = this.lmMask;
            this.$emit("lmClose",fakt);

          },
            submit:function () {
              var that = this;
                if(this.phone){
                    this.axios.post('http://travel.xiangbaoche.cn/api.php/api/Gbook/index',
                        {
                            name:that.name,
                            phone:that.phone,
                            city_id:that.publicData.Cityaid,
                            remark:that.remark,
                            type:that.type,
                            site_type:2,
                            site:4,
                        }
                    ).then(function (res) {
                        console.log(res);
                        if(res.data.resCode == 1){
                            Toast('您的留言已提交成功，工作人员15分钟内回复您。');
                            that.close();
                        }else {
                            Toast({type:'html',message:res.data.resMsg,onClose() {

                                }});
                        }
                    }).catch(function (err) {
                        console.log(err);
                        Toast("提交失败，请稍后重试");
                    });
                }else {
                    Toast('请填写您的联系方式，方便客服联系您');
                }
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clear {overflow: hidden;}
    .clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}

    .leaveMessage{position: fixed;left: 72px;top:234px;width: 606px;background: #ffffff;z-index: 9}
    .lmMain{background: #ffffff;margin: 0 60px;}
    .lmMainTitle{height: 116px;line-height: 116px;position: relative}
    .lmtTitle{text-align: center;font-size:32px;font-family:PingFangSC-Medium;font-weight:700;color:rgba(44,62,80,1);}
    .lmtImg{width:36px;height:36px;position: absolute;right: 0;top:40px;display: flex}
    .lmtImg img{width: 100%;height: 100%;}
    .lmMainContent input,.lmMainContent select{width: 100%;height: 68px;line-height: 68px;font-size:28px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(159,176,192,1);padding-left: 20px;box-sizing: border-box;
    background: #f6f6f6;margin-bottom: 20px;outline: none;border:2px solid rgba(229,229,229,1)}
    .lmMainContent textarea{width: 100%;height: 144px;padding: 14px 20px;box-sizing: border-box;font-size:28px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(159,176,192,1);
      border:2px solid rgba(229,229,229,1);background: #f6f6f6;line-height: normal}
    .lmMainSubmit{width: 100%;height: 68px;line-height: 68px;text-align: center;margin: 32px 0 52px 0}
    .lmMainSubmit button{width: 100%;height: 100%;background:rgba(29,210,175,1);border-radius:4px;font-size:28px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(255,255,255,1);border: none;
    outline: none;}
</style>
<style>
    .leaveMessage{z-index: 10!important;}
    .van-toast{font-size: 26px;line-height: 40px;}
</style>



// WEBPACK FOOTER //
// src/components/LeaveMessage/LeaveMessage.vue